import React, { useEffect } from 'react'
import { NodeViewWrapper } from '@tiptap/react'
import { useEmoji, useShortcode } from 'state/emoji/mutators'
import { DisplayEmoji } from 'components/symbol'

const EmojiNode = ({ node, updateAttributes }) => {
    const emojiResolved = useEmoji({
        shortcode: node.attrs.name,
        queryOptions: {
            enabled: !!node.attrs.name && !node.attrs.emoji
        }
    })

    const shortnameResolved = useShortcode({
        emoji: node.attrs.emoji,
        queryOptions: {
            enabled: !!node.attrs.emoji && !node.attrs.name
        }
    })

    useEffect(() => {
        if(emojiResolved) {
            updateAttributes(emojiResolved)
        }
    }, [emojiResolved, updateAttributes])

    useEffect(() => {
        if(shortnameResolved) {
            updateAttributes(shortnameResolved)
        }
    }, [shortnameResolved, updateAttributes])

    return (
        <NodeViewWrapper
            as="span"
            className="emoji">
            <DisplayEmoji
                name={node.attrs.name}
                emoji={node.attrs.emoji}
                naked />
        </NodeViewWrapper>
    )
}

export default EmojiNode